import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useUserStatus } from './hooks';
import { setMobileActiveSide } from '../../actions/mobileSide';
import { closeUserCard } from '../../actions/userCard/closeUserCard';
import { openUserCard } from '../../actions/userCard/openUserCard';
import { ChatHeaderUser } from '../../components/ChatHeader';
import { useCompanionData, useMailingUxfeedbackCampaign } from '../../hooks';
import { currentOpenChatIDSelector, hostTypeSelector } from '../../selectors';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { ChatHeaderCallButtonContainer } from '../ChatHeaderCallButtonContainer';
import { ChatHeaderUserCardButtonContainer } from '../ChatHeaderUserCardButtonContainer';
import { ChatMenuContainer } from '../ChatMenuContainer';

export const ChatHeaderUserContainer = () => {
  const hostType = useSelector(hostTypeSelector);
  const chatId = useSelector(currentOpenChatIDSelector);

  const isIframe = hostType === EHostType.Frame;
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;
  const callButtonNode = isMobile && !isIframe ? <ChatHeaderCallButtonContainer /> : null;
  const chatMenuNode = !isIframe ? <ChatMenuContainer /> : null;

  const dispatch = useDispatch();

  const { companionId, companionName, accountTypeName, companionIdStr } = useCompanionData(chatId);
  const { companionStatus } = useUserStatus(companionId as number);
  const { sendMailingUxfeedbackCampaign } = useMailingUxfeedbackCampaign();

  const handleClickBack = () => {
    dispatch(closeUserCard());
    dispatch(setMobileActiveSide(EMobileLayoutActiveSide.Left));
    sendMailingUxfeedbackCampaign();
  };

  const handleClickName = () => {
    if (chatId) {
      dispatch(openUserCard(companionId));
    }
  };

  return (
    <ChatHeaderUser
      isIframe={isIframe}
      handleClickBack={handleClickBack}
      handleClickName={handleClickName}
      companionName={companionName}
      companionTypeName={accountTypeName}
      companionIdStr={companionIdStr}
      callButtonNode={callButtonNode}
      chatMenuNode={chatMenuNode}
      companionStatus={companionStatus}
      userCardButtonNode={<ChatHeaderUserCardButtonContainer />}
    />
  );
};
